import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormControlDirective, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';

export interface Product {
    id?: string;
    code?: string;
    name?: string;
    description?: string;
    price?: number;
    quantity?: number;
    inventoryStatus?: string;
    category?: string;
    image?: string;
    rating?: number;
}

@Component({
    selector: 'app-apqp',
    templateUrl: './apqp.component.html',
    styleUrls: ['./apqp.component.scss']
})
export class APQPComponent implements OnInit {

    msgs: Message[] = [];
    assignSupplierData: any;
    filterval: string;
    orderCo: string;
    orderNumber: string;
    orderType: string;
    dateUpdated: string;
    foreignUnitCost: string;
    exchangeRate: string;
    currency: string;
    glOffset: string;
    buyerNumber: string;
    invoiceNumber: string;
    paymentTerm: string;
    extendedPrice: string;
    unitPrice: string;
    quantityOpen: string;
    quantityremaining: null;
    quantityOrdered: string;
    unitOfMeasure: string;
    valueStream2: string;
    valueStream1: string;
    valueStreamDesc: string;
    valueStream: string;
    lastStatusDesc: string;
    lastStatus: string;
    nextStatusDesc: string;
    nextStatus: string;
    lineType: string;
    description2: string;
    description1: string;
    foreignExtendedPrice: string;
    orderSuffix: string;
    lineNumber: string;
    businessUnit: string;
    addressNumber: string;
    billToName: string;
    shipToNumber: string;
    shipToName: string;
    orderDate: string;
    requestedDate: string;
    scheduledPickDate: string;
    cancelDate: string;
    shortItemNumber: string;
    itemNumber: string;
    entyDate: string;
    orderLineStatus: string;
    constructor(private route: Router, public _apiService: ApiServiceService, private confirmationService: ConfirmationService, private primengConfig: PrimeNGConfig, public _utility: AppUtility, private fb: FormBuilder, private messageService: MessageService) { }
    loading: boolean = true;
    supplierId: any;
    submitButton: string = 'Submit'
    apqpData: any = [];
    enquiry_dropdown: any = [];
    document_dropdown: any = [];

    products1: Product[];

    products2: any;
    roleName: any;
    selected: any;
    clonedProducts: { [s: string]: Product; } = {};

    apqpGroup = new FormGroup({
        enquiryId: new FormControl(''),
        supplierId: new FormControl(''),
        supplierId2: new FormControl('', [Validators.required]),
        documentPath: new FormControl('')
    })

    ngOnInit(): void {
        this.loading = false;
        this.primengConfig.ripple = true;
        this.roleName = this._utility.getLocalStorageDetails().roleName;
        this.supplierId = this._utility.getLocalStorageDetails().supplierId ?? '';
        if (this.supplierId) {
            this.apqpGroup.controls['supplierId'].setValue(this.supplierId)
        }
        this.getStatic();
        this.callFunctionBasedOnRole()
    }

    breadcrumb = [
        {
            title: 'Supplier APQP Documents',
            subTitle: 'Dashboard'
        }
    ]

    enquiryId: any;
    display: boolean = false;
    supplierList: any = [];
    submitItemId: any = '';
    lastUploaded: any;
    showItemName: any = '';
    jdedata: any[] = []
    //get apqp list
    getAPQPList() {
        this.submitItemId = this.submitItemId;
        this.showItemName = this.showItemName;
        // ;
        let object: any = {};
        if (this.apqpGroup.valid && this.roleName != 'Supplier' && this.apqpGroup.value.supplierId2) {
            this._utility.loader(true);
            if (this.apqpGroup.value.supplierId2) {
                object = {
                    enquiryId: this.selectedEnquiryId,
                    supplierId: this.apqpGroup.value.supplierId2['supplierId'],
                    itemId: this.selectItemId,
                }

                this._apiService.getApqpData(object).then((res: any) => {
                    this._utility.loader(false);
                    if (res.success) {
                        this.apqpData = res.returnValue;
                        this.apqpData.forEach((v: any, index: any) => { v.index = index, v.targetDate = moment(v.targetDate).format('MM/DD/YYYY') })
                        this.display = true;
                        this.lastUploaded = this.apqpData[0]?.lastUploaded;
                    }
                    else {
                        this.apqpData = [];
                        this.display = false;
                        this.lastUploaded = '';
                        this._apiService.showMessage(res.message, 'error');
                    }


                    this.selectAllCheckbox('', 'required_list')
                    this.selectAllCheckbox('', 'docRequired_list')
                })
            }
        }

        else if (this.roleName == 'Supplier') {
            this._utility.loader(true);
            object = {
                enquiryId: this.selectedEnquiryId,
                supplierId: this.apqpGroup.value.supplierId,
                itemId: this.selectItemId
            }

            this._apiService.getApqpData(object).then((res: any) => {
                this._utility.loader(false);
                if (res.success) {
                    this.apqpData = res.returnValue;
                    this.apqpData.forEach((v: any, index: any) => { v.index = index, v.targetDate = moment(v.targetDate).format('MM/DD/YYYY') })
                    this.display = true;
                    this.lastUploaded = this.apqpData[0]?.lastUploaded;
                }
                else {
                    this.apqpData = [];
                    this.display = false;
                    this.lastUploaded = '';
                    this._apiService.showMessage(res.message, 'error');
                }


                this.selectAllCheckbox('', 'required_list')
                this.selectAllCheckbox('', 'docRequired_list')
            })

        }

        else {
            this._apiService.showMessage('Please fill form details', 'error');
        }
    }


    //save apqp list
    onRowEditSave() {
        console.log(this.apqpData);
        this.apqpData.forEach((v: any) => { v.enquiryId = JSON.parse(this.selectedEnquiryId), v.supplierId = this.apqpGroup.value.supplierId ? this.apqpGroup.value.supplierId : this.apqpGroup.value.supplierId2['supplierId'], v.targetDate = this._utility.dateTimeChange(v.targetDate) })
        let object: any = {
            enquiryId: this.selectedEnquiryId,
            supplierId: this.apqpGroup.value.supplierId ? this.apqpGroup.value.supplierId : this.apqpGroup.value.supplierId2['supplierId'],
            APQPDetails: this.apqpData,
            itemId: this.selectItemId
        };
        this._apiService.postAPQPDocument(object).then((res: any) => {
            console.log(res);
            if (res.success) {
                this._apiService.showMessage(res.message, 'success');
                this.getAPQPList();
            }

            else {
                this._apiService.showMessage(res.message, 'error')
            }

        })
    }

    //upload qpqp document
    upload_doc(event: any, product: any) {
        let file = this._utility.onFileChange(event, 'xlsx');
        if (product.length > 0) {
            if (file != false && product[0].apqpId > 0) {
                this._utility.loader(true);
                let formData = new FormData();
                formData.append('supplierId', this.apqpGroup.value.supplierId);
                formData.append('enquiryId', this.selectedEnquiryId);
                formData.append('apqpId', product[0].apqpId);
                formData.append('itemId', this.selectItemId);
                formData.append('filepath', file);
                this._apiService.putAPQPDocument(formData).then((res: any) => {
                    this._utility.loader(false);
                    if (res.success) {
                        this._apiService.showMessage(res.message, 'success');
                        this.display = false;
                        this.apqpGroup.reset();
                        this.apqpGroup.controls['enquiryId'].setValue('');
                        this.apqpGroup.controls['supplierId'].setValue(this.supplierId ?? '');
                        this.apqpData = [];
                        this.enquiryItemDetails = [];
                    }

                    else {
                        this._apiService.showMessage(res.message, 'error');
                    }
                })
            }
        }

        else {
            this._apiService.showMessage('please select part', 'error');
        }

    }

    // onRole
    selectedEnquiryId: any;
    selectItemId: any;
    selectItemName: string = '';
    callFunctionBasedOnRole(event?: any) {
        // console.log(event.target.value);
        // let object = this.enquiry_dropdown[Number(event.target.value)];
        // this.selectItemId = object.itemId;
        // this.selectedEnquiryId = object.id;
        // this.selectItemName = object.cond2;
        if (this.roleName == 'Supplier') {
            this.getAPQPList();
        }

        else {
            this._utility.loader(true);
            // let object1 = {
            //     Mode: 'ComparisionenquiryWisesupplier',
            //     cond3: object?.id,
            //     supplierId: object.itemId
            // }
            this.display = false;
            this._apiService.getSupplier().then((res: any) => {
                console.log(res);
                if (res.success) {
                    this._utility.loader(false);
                    this.supplierList = res.returnValue;
                    this.apqpGroup.controls['supplierId2'].setValue('');
                    this.apqpData = [];
                }

                else {
                    this._utility.loader(false);
                    this.apqpData = [];
                    this.supplierList = [];
                    this.apqpGroup.controls['supplierId2'].setValue('');
                }
            })
        }
    }

    // get parts by enquiry id
    getPartDetails() {
        let variable = this.enquiry_dropdown.filter(res => {
            return res.id == this.apqpGroup.value.enquiryId
        })

        let object1 = {
            enquiryNo: variable[0].value
        }

        this.getPartsById(object1);
    }

    enquiryItemDetails: any = [];
    async getPartsById(enquiryNo) {
        console.log(enquiryNo);
        let enquiryNo1 = enquiryNo.enquiryNo.split('-')
        await this._apiService.getenquiryDetailsById(enquiryNo1[0])
            .then((res: any) => {
                this._utility.loader(false);
                console.log(res.returnValue);
                if (res.success == true) {
                    this.enquiryItemDetails = res.returnValue.enquiryItemDetails;
                }
                else {
                    this.enquiryItemDetails = [];
                }
            })

            .catch((error: any) => {
                this._utility.loader(false);
                this._apiService.showMessage(error.message, 'error');
            })

    }


    updateFile() {
        this.apqpData[0].documentPath = '';
    }

    // get all drawing
    editUploadedDrawing: any = [];
    displayDialog: boolean = false;
    getAllItemDrawing(itemId) {
        this._apiService.getEnggDrawing(itemId).then((res: any) => {
            if (res.success) {
                this.editUploadedDrawing = res.returnValue;
            }

            else {
                this.editUploadedDrawing = [];
            }
        })

        if (this.editUploadedDrawing.length > 0) {
            this.displayDialog = true;
        }

        console.log(this.editUploadedDrawing);
    }


    //get dropdowns
    getStatic() {
        this._apiService.dropdowndata('document')
            .then((res: any) => {
                if (res.success) {
                    this.document_dropdown = res.returnValue;
                }
            })
        let object = {
            Mode: 'EnquiryAPQP',
            roleName: this._utility.getLocalStorageDetails().roleName,
            supplierId: this.supplierId,
            userIdC: this._utility.getLocalStorageDetails().loginId
        }
        this._apiService.dropdowndata('enquiry', object)
            .then((res: any) => {
                if (res.success) {
                    this.enquiry_dropdown = res.returnValue;
                }
            })

    }


    allCheckboxRequired: boolean = false;
    allDocCheckbox: boolean = false;
    selectAllCheckbox(event: any, string?: any) {
        if (string == 'required') {
            if (event.target.checked) {
                this.apqpData.forEach((res: any) => {
                    res.required = true;
                })
            }

            else {
                this.apqpData.forEach((res: any) => {
                    res.required = false;
                })
            }
        }

        else if (string == 'requiredone') {
            if (!event.target.checked) {
                this.allCheckboxRequired = false;
            }

            else {
                console.log(this.apqpData);
                let value = this.apqpData.filter(res => res.required == false);
                console.log(value);
                if (value.length == 0) {
                    this.allCheckboxRequired = true;
                }
            }
        }

        else if (string == 'docRequiredone') {
            if (!event.target.checked) {
                this.allDocCheckbox = false;
            }

            else {
                console.log(this.apqpData);
                let value = this.apqpData.filter(res => res.docReq == false);
                console.log(value);
                if (value.length == 0) {
                    this.allDocCheckbox = true;
                }
            }
        }
        else if (string == 'docRequired') {
            if (event.target.checked) {
                this.apqpData.forEach((res: any) => {
                    res.docReq = true;
                })
            }

            else {
                this.apqpData.forEach((res: any) => {
                    res.docReq = false;
                })
            }
        }

        else if (string == 'required_list') {

            let value = this.apqpData.filter(res => res.required == false);
            console.log(value);
            if (value.length == 0) {
                this.allCheckboxRequired = true;
            }
            else {
                this.allCheckboxRequired = false;
            }
        }
        else if (string == 'docRequired_list') {
            let value = this.apqpData.filter(res => res.docReq == false);
            if (value.length == 0) {
                this.allDocCheckbox = true;
            }
            else {
                this.allDocCheckbox = false;
            }
        }
    }
    getallpartitem() {
        if (this.apqpGroup.valid) {
            const selectedSupplier = this.apqpGroup.get('supplierId2').value;
            this._utility.loader(true)


            this._apiService.jdedatabyid(selectedSupplier).then(response => {
                this._utility.loader(false)
                this.jdedata = response.returnValue;
                console.log('API response:', this.jdedata);
                if (response.returnValue == false)
                    this._apiService.showMessage(response.message, "error");

                // handle response
            }).catch(error => {
                console.error('API error:', error);
                this._apiService.showMessage(error.message, "error");
                this._utility.loader(false)
            });
        } else {
            this._utility.loader(false)
            this._apiService.showMessage('Please Select Supplier', "error");
            this.apqpGroup.markAllAsTouched();
        }
    }
    reset(dt2) {

        dt2.reset();
        this.filterval = ''
        this.orderCo = ''
        this.orderNumber = ''
        this.orderType = ''
        this.dateUpdated = ''
        this.foreignUnitCost = ''
        this.exchangeRate = ''
        this.currency = ''
        this.glOffset = ''
        this.buyerNumber = ''
        this.invoiceNumber = ''
        this.paymentTerm = ''
        this.extendedPrice = ''
        this.unitPrice = ''
        this.quantityOpen = ''
        this.quantityremaining = null
        this.quantityOrdered = ''
        this.unitOfMeasure = ''
        this.valueStream2 = ''
        this.valueStream1 = ''
        this.valueStreamDesc = ''
        this.valueStream = ''
        this.lastStatusDesc = ''
        this.lastStatus = ''
        this.nextStatusDesc = ''
        this.nextStatus = ''
        this.lineType = ''
        this.description2 = ''
        this.description1 = ''
        this.foreignExtendedPrice = ''
        this.orderSuffix = ''
        this.lineNumber = ''
        this.businessUnit = ''
        this.addressNumber = ''
        this.billToName = ''
        this.shipToNumber = ''
        this.shipToName = ''
        this.orderDate = ''
        this.requestedDate = ''
        this.scheduledPickDate = ''
        this.cancelDate = ''
        this.shortItemNumber = ''
        this.itemNumber = ''
        this.entyDate = ''
        this.orderLineStatus = ''
    }
    //   onXLSExport(){
    // //   console.log("ere",this.selected);
    // console.log(this.jdedata.filter(item => item.selected),  "eroroorrr");


    //   } 
    sendSelectedData() {
        const selectedpart = this.jdedata.filter(item => item.selected)
        console.log(selectedpart);
        if (selectedpart.length == 0) {
            this._apiService.showMessage('Please Select Atleast One Part', "error")
            return;
        }

        const payload = {
            SupplierId: selectedpart[0]?.supplierId,
            OrderNumber: selectedpart[0]?.orderNumber,
            LineNumber: selectedpart[0]?.lineNumber,
             ItemDescription: selectedpart[0]?.itemDesc,
            ItemNumber: selectedpart[0]?.itemNumber,
        };
        
        this._apiService.postAPQPDocument(payload).then(response => {
            this._utility.loader(false)
            if (response.success == true)
                this._apiService.showMessage(response.message, "success");
                this.getallpartitem()
        }).catch(error => {
            console.error('API error:', error);
            this._apiService.showMessage(error.message, "error");
            this._utility.loader(false)
        });
    }

}
